module.exports = __webpack_public_path__ + "img/20180815_154807_250.195894ca.jpg";